<template>
	<div class="v5-select-content" v-show="show">
		<div class="v5-line-one"></div>
		<div class="v5-line-two"></div>
		<scroller :snapping="snapping" :size="size" :positionY="positionY" :autoResize="false" @on-scrollend="scrollEnd">
			<ul class="v5-select-ul" :id="containerId">
				<li v-for="(item, index) in list" class="v5-select-li" :key="index">{{item}}</li>
			</ul>
		</scroller>
		<div class="v5-sel-top"></div>
		<div class="v5-sel-bottom"></div>
	</div>
</template>
<script>
	import Scroller from './../scroller';
	export default {
		name: 'v5-select',
		props: {
			snapping: {
				type: Boolean,
				default: true
			},
			dataList: {
				type: Array,
				default: []
			},
			selectedIndex: {
				type: Number,
				default: 2
			},
			show: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				containerId: 'ul-' +
					Math.random()
					.toString(36)
					.substring(3, 10),
				container: undefined,
				list: ['', ''].concat(this.dataList, ['', '']),
				positionY: 0,
				snapHeight: 1,
				firstShow: true // 只有初始化展示进行定位，后面滚动之后的定位不再进行定位计算
			};
		},
		watch: {
			show(val) {
				if (val) {
					// 初始化滚动行高及初始化位置
					if (this.snapping && this.snapHeight === 1) {
						this.$nextTick(function () {
							this.snapHeight =
								this.container.offsetHeight / this.list.length;
							this.positionY = this.snapHeight * this.selectedIndex;
						});
					}
				}
			}
		},
		computed: {
			size: function () {
				return this.list.length;
			}
		},
		mounted() {
			this.container = document.getElementById(this.containerId);
		},
		components: {
			Scroller
		},
		methods: {
			scrollEnd(position) {
				// 只存下展示时位置
				if (this.show) {
					let top = position.top,
						selectedIndex = Math.round(top / this.snapHeight); // 滚动停止之后滚动距离顶部的个数
					this.$emit('on-scrollend', selectedIndex);
				}
			}
		}
	};

</script>
<style lang="scss" scoped>
	@import './style.scss';

</style>
